export const ADD_GROUP = 'ADD_GROUP';
export const ADD_CALCUL_ERROR = 'ADD_CALCUL_ERROR';

export const ADD_TO_LIST = 'ADD_TO_LIST';
export const ADD_CALCUL_RESULTAT = 'ADD_CALCUL_RESULTAT';
export const ADD_CALCUL_HISTORIQUE = 'ADD_CALCUL_HISTORIQUE';
export const ADD_WORK_ID = 'ADD_WORK_ID';
export const ADD_TO_LIST_CONDITION = 'ADD_TO_LIST_CONDITION';
export const ADD_LIST = 'ADD_LIST';
export const ADD_ARTICLE = 'ADD_ARTICLE';
export const ADD_ATL_ERROR = 'ADD_ATL_ERROR';

export const ADD_HOW_TO_LINK = 'ADD_HOW_TO_LINK';
export const ADD_HOW_TO_TEXT = 'ADD_HOW_TO_TEXT';
export const ADD_WORK_TITLE = 'ADD_WORK_TITLE';
export const ADD_WORK_DESCRIPTION = 'ADD_WORK_DESCRIPTION';


// MODAL
export const ADD_MODAL_EXPORT = 'ADD_MODAL_EXPORT';
export const ADD_MODAL_HISTORIQUE = 'ADD_MODAL_HISTORIQUE';
export const ADD_MODAL_ADDTOLIST = 'ADD_MODAL_ADDTOLIST';
export const ADD_MODAL_LOADER = 'ADD_MODAL_LOADER';

// Local storage
export const USER_TOKEN = 'USER_TOKEN';
export const ENV = 'ENV';



// WEBPACK FOOTER //
// ./src/constants/ConfigFileConstant.js